<template lang="pug">
.app(:class="{ 'sso-patient-view': isSsoPatientView, 'clinical-portal-view': isClinicalPortalView  }")
  template(v-if="isClinicalPortalView || isClinicalPortalRoute")
      the-alert
      router-view
  template(v-else-if="!isSsoPatientView")
    the-header(:logout="goToLogout")
    section.content-wrapper
      the-alert
      the-modal
      the-sidebar
      main.main(aria-label="main")
        template(v-if="!user")
          .loading-dots
            .dot1
            .dot2
            .dot3
        template(v-else)
          router-view
  //- SSO Patient view wrapper
  template(v-else-if="isSsoPatientView")
    the-header(
      :logout="goToLogout"
      :is-sso-patient-view="true")
    section.sso-content-wrapper
      the-alert
      the-modal
      main.main(aria-label="main")
        template(v-if="!user")
          .loading-dots
            .dot1
            .dot2
            .dot3
        template(v-else)
          router-view
</template>

<script>
import 'es6-promise/auto';
import TheAlert from './components/general/TheAlert.vue';
import TheModal from './components/general/TheModal.vue';
import TheHeader from './components/general/TheHeader.vue';
import TheSidebar from './components/general/TheSidebar.vue';
import { mapGetters, mapActions } from 'vuex';
import auth from '@/services/authSvc.js';

const components = {
  TheAlert,
  TheModal
};

if (!auth.isClinicalPortal()) {
  components['TheSidebar'] = TheSidebar;
  components['TheHeader'] = TheHeader;
}

export default {
  name: 'App',
  components,
  data() {
    return {
      isSsoPatientView:
        this.$route &&
        (this.$route.name === 'ssoPatient' ||
          this.$route.name === 'SinglePatientNotFound'),
      isClinicalPortalRoute:
        this.$route && this.$route.name === 'ClinicalPortalView'
    };
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'user', 'isClinicalPortalView'])
  },
  methods: {
    initBodyScrollListeners() {
      // Listen for root events - block-body-scroll & unblock-body-scroll
      // Note: Root events can be fired from any component
      this.$root.$on('block-body-scroll', () => {
        document.querySelector('body').classList.add('block-body-scroll');
      });
      this.$root.$on('unblock-body-scroll', () => {
        document.querySelector('body').classList.remove('block-body-scroll');
      });
    },
    ...mapActions(['loadUserData', 'loadApiConfig', 'goToLogout'])
  },
  created() {
    if (this.isLoggedIn) {
      this.loadUserData();
      this.loadApiConfig();
      this.initBodyScrollListeners();
    }
  }
};
</script>
<style src="./styles/global.scss" lang="scss"></style>
<style lang="scss" scoped>
.app {
  .sso-content-wrapper {
    padding: 14px;
  }
}
</style>
